import './home.scss';

import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Translate } from 'react-jhipster';
import { Row, Col, Alert } from 'reactstrap';

import { useAppSelector } from 'app/config/store';

export const Home = () => {
  const account = useAppSelector(state => state.authentication.account);

  return (
    <Row>
      <Col md="9">{account?.login ? <Navigate to={'/admin/health'} replace /> : <Navigate to={'/login'} replace />}</Col>
    </Row>
  );
};

export default Home;
